import { heFetch } from './HeFetch';
export var getStatus = function () {
    return heFetch.get('/kyc/verification/status');
};
export var runVerification = function (config) {
    return heFetch.post('/kyc/verification/config', {
        data: config
    });
};
